import { AnimTiltedCard } from '@readdy/anim/card/tilted-card/react';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/a401edf6-423c-4e89-a657-b2993c8ec07c_compressed_Screenshot-2026-07-22-011236.webp"
          alt="D'CURE Gelato cozy cafe interior with warm ambient lighting"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-0">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-8">
          <div className="flex-1 flex flex-col items-center lg:items-start text-center lg:text-left">
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-primary-300 glow-text leading-tight">
              D'CURE GELATO
            </h1>
            <p className="font-body text-base md:text-lg text-foreground-100/80 mt-6 max-w-md italic">
              Malacca's first artisan gelato cafe. Crafted fresh daily with the finest natural ingredients
            </p>
            <a
              href="#products"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="mt-8 inline-block bg-primary-500 text-background-950 font-label text-sm font-semibold tracking-[0.12em] px-8 py-3.5 rounded-full hover:bg-primary-400 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              EXPLORE OUR MENU
            </a>
          </div>

          <div className="flex-1 flex justify-center lg:justify-end">
            <div className="relative w-[320px] h-[420px] md:w-[400px] md:h-[520px]">
              <AnimTiltedCard maxTilt={12} strength={0.08}>
                <div className="w-full h-full rounded-3xl overflow-hidden">
                  <img
                    src="https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/28784b98-29d1-49dd-90b0-c04e67da9910_compressed_Screenshot-2026-07-22-010722.webp"
                    alt="Hand holding a white paper cup of vanilla gelato from D'CURE Gelato"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </AnimTiltedCard>
              <div className="absolute -inset-2 rounded-3xl bg-primary-400/10 blur-3xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-foreground-100/60"></i>
      </div>
    </section>
  );
}